import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BarclaysRequest } from '../entities/barclays-request.class';

@Component({
  selector: 'app-barclays-form-legacy',
  templateUrl: './barclays-form-legacy.component.html',
  styleUrls: ['./barclays-form-legacy.component.scss'],
  standalone: false
})
export class BarclaysFormLegacyComponent implements OnInit {
  @ViewChild('barclaysForm') barclaysForm: ElementRef;

  barclaysFormInfo: BarclaysRequest;

  constructor() {
    // This is intentional
  }

  ngOnInit() {
    // This is intentional
  }

  /**
   * Submits the hidden Barclays Form and redirects to the Barclays Payment page
   */
  startBarclaysPayment() {
    setTimeout(() => {
      this.barclaysForm.nativeElement.submit();
    });
  }
}
